import React, { Fragment, useEffect } from "react";
import PageBannerComponent from "../Components/Common/PageBannerComponent";
import AuthLayout from "../Layout/AuthLayout";
import { useNavigate } from "react-router-dom";
import { useGetEventsMutation } from "../Store/api/DataApi";
import EventItemComponent from "../Components/AppliedEvents/EventItemComponent";

export default function AppliedEvents() {
  const [getEvents, { data }] = useGetEventsMutation();
  const navigate = useNavigate();

  useEffect(() => {
    if (data?.error !== undefined && data?.error === "Invalid token!") {
      navigate("/logout");
    }
  }, [data, navigate]);

  useEffect(() => {
    getEvents(1);
  }, [getEvents]);

  return (
    <Fragment>
      <PageBannerComponent title="Events/Workshop" />
      <AuthLayout>
        <div className="inner-box my-resume">
          <div className="row">
            {data?.data?.length > 0 ? (
              data?.data?.map((event, i) => (
                <EventItemComponent item={event} key={i} />
              ))
            ) : (
              <div className="col text-center mt-3">No Event found</div>
            )}
            {/* <div className="col-lg-4 col-md-6">
              <div className="single-service">
                <h4>Resume Writing 222</h4>
                <h6>Facilitated By Learning Partners</h6>
                <p className="pt-20">
                  <span>
                    <i className="fa fa-calendar" /> &nbsp; 30 Nov 2019
                  </span>
                  <br />
                  <span>
                    <i className="fa fa-clock-o" /> &nbsp; 5 - 6 pm
                  </span>
                  <br />
                  <span>
                    <i className="fa fa-thumb-tack" /> &nbsp; Chandigarh &amp;
                    Delhi
                  </span>
                  <br />
                  <span>
                    <i className="fa fa-user" /> &nbsp; For LGBT+ Community only
                  </span>
                  <br />
                  <span>
                    <i className="fa fa-book" /> &nbsp; EV-1
                  </span>
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-service">
                <h4>Resume Writing 222</h4>
                <h6>Facilitated By Learning Partners</h6>
                <p className="pt-20">
                  <span>
                    <i className="fa fa-calendar" /> &nbsp; 30 Nov 2019
                  </span>
                  <br />
                  <span>
                    <i className="fa fa-clock-o" /> &nbsp; 5 - 6 pm
                  </span>
                  <br />
                  <span>
                    <i className="fa fa-thumb-tack" /> &nbsp; Chandigarh &amp;
                    Delhi
                  </span>
                  <br />
                  <span>
                    <i className="fa fa-user" /> &nbsp; For LGBT+ Community only
                  </span>
                  <br />
                  <span>
                    <i className="fa fa-book" /> &nbsp; EV-1
                  </span>
                </p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="single-service">
                <h4>Resume Writing 222</h4>
                <h6>Facilitated By Learning Partners</h6>
                <p className="pt-20">
                  <span>
                    <i className="fa fa-calendar" /> &nbsp; 30 Nov 2019
                  </span>
                  <br />
                  <span>
                    <i className="fa fa-clock-o" /> &nbsp; 5 - 6 pm
                  </span>
                  <br />
                  <span>
                    <i className="fa fa-thumb-tack" /> &nbsp; Chandigarh &amp;
                    Delhi
                  </span>
                  <br />
                  <span>
                    <i className="fa fa-user" /> &nbsp; For LGBT+ Community only
                  </span>
                  <br />
                  <span>
                    <i className="fa fa-book" /> &nbsp; EV-1
                  </span>
                </p>
              </div>
            </div> */}
          </div>
        </div>
      </AuthLayout>
    </Fragment>
  );
}
